var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultipleBookingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1827 8.76623L8.746 13.7579C8.58964 13.9339 8.39777 14.0747 8.18303 14.1711C7.9683 14.2676 7.73557 14.3175 7.50017 14.3175C7.26477 14.3175 7.03204 14.2676 6.81731 14.1711C6.60257 14.0747 6.4107 13.9339 6.25434 13.7579L1.81767 8.76623C1.54636 8.46112 1.39648 8.06703 1.39648 7.65873C1.39648 7.25044 1.54636 6.85634 1.81767 6.55123L6.25434 1.55956C6.4107 1.3836 6.60257 1.24276 6.81731 1.14631C7.03204 1.04987 7.26477 1 7.50017 1C7.73557 1 7.9683 1.04987 8.18303 1.14631C8.39777 1.24276 8.58964 1.3836 8.746 1.55956L13.1827 6.55123C13.454 6.85634 13.6039 7.25044 13.6039 7.65873C13.6039 8.06703 13.454 8.46112 13.1827 8.76623Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.97124L11.2542 1.5604C11.4105 1.38444 11.6024 1.2436 11.8171 1.14715C12.0319 1.0507 12.2646 1.00084 12.5 1.00084C12.7354 1.00084 12.9681 1.0507 13.1829 1.14715C13.3976 1.2436 13.5895 1.38444 13.7458 1.5604L18.1825 6.55207C18.4536 6.85713 18.6033 7.25105 18.6033 7.65915C18.6033 8.06726 18.4536 8.46118 18.1825 8.76624L13.7458 13.7579C13.5895 13.9339 13.3976 14.0747 13.1829 14.1712C12.9681 14.2676 12.7354 14.3175 12.5 14.3175C12.2646 14.3175 12.0319 14.2676 11.8171 14.1712C11.6024 14.0747 11.4105 13.9339 11.2542 13.7579L10 12.3454",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleBookingIcon);
export default __webpack_public_path__ + "static/media/multipleBookingIcon.364d978d.svg";
export { ForwardRef as ReactComponent };